export interface CookieConsent {
  analytics: boolean;
  timestamp: string;
}

const CONSENT_KEY = "cookieConsent";

export function getConsent(): CookieConsent | null {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    return JSON.parse(stored) as CookieConsent;
  } catch {
    return null;
  }
}

export function setConsent(consent: CookieConsent): void {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
}

export function hasConsented(): boolean {
  return getConsent() !== null;
}

export function acceptAll(): void {
  setConsent({ analytics: true, timestamp: new Date().toISOString() });
}

export function rejectAll(): void {
  setConsent({ analytics: false, timestamp: new Date().toISOString() });
  removeAnalyticsCookies();
}

export function revokeConsent(): void {
  localStorage.removeItem(CONSENT_KEY);
  removeAnalyticsCookies();
}

function removeAnalyticsCookies(): void {
  const cookiesToRemove = ["_ga", "_gid", "_gat"];
  const domains = [window.location.hostname, `.${window.location.hostname}`];

  cookiesToRemove.forEach((name) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
  });
}
